import { post } from '@/util/request'

export default {

    /**
     * 导出预警舆情
     * */
    warn: query => post(`/export/warn`, query),

}
